import '../../assets/components/Label/label.css';const l = "_label_1899a_1", e = "_filled_1899a_7", t = "_outlined_1899a_10", _ = {
  label: l,
  filled: e,
  outlined: t
};
export {
  _ as default,
  e as filled,
  l as label,
  t as outlined
};
